const STEPS = [
  ["Abra o Auto Reply", "Edite a regra que você já criou (ou crie uma nova pelo ícone +)."],
  ["Mensagem recebida", "Em Received message pattern, deixe marcado All."],
  ["Configurações & IA", "Na aba Config & IA deste painel, cole a URL do painel IPTV (a antiga do Auto Reply) e salve."],
  ["Servidor próprio", "Em Resposta com servidor próprio, mantenha Conectar ao servidor próprio marcado."],
  ["Troque a URL", "Apague a URL do painel no campo Url do Servidor e cole a URL copiada acima."],
  ["Desmarque outras IAs", "Deixe Gemini, ChatGPT e Dialogflow do app desmarcados — a IA roda aqui."],
  ["Salve e ative", "Toque no ✓ para salvar e ative o ChatBot. Teste mandando uma mensagem de outro número."],
];

export const SetupGuide = () => (
  <section data-testid="setup-guide">
    <h2 className="font-heading text-base md:text-lg font-semibold">Como configurar no Auto Reply</h2>
    <ol className="mt-4 grid sm:grid-cols-2 gap-3">
      {STEPS.map(([title, text], i) => (
        <li key={title} className="step-card" style={{ animationDelay: `${i * 60}ms` }} data-testid={`setup-step-${i + 1}`}>
          <span className="step-num">{String(i + 1).padStart(2, "0")}</span>
          <div>
            <p className="font-medium text-sm sm:text-base">{title}</p>
            <p className="text-xs sm:text-sm text-[#9CA3AF] mt-1 leading-relaxed">{text}</p>
          </div>
        </li>
      ))}
    </ol>
  </section>
);
